'use client';

// Global
import React, { JSX, useEffect } from 'react';

// Local
import { Content } from '.generated/Feature.CW.model';
import { withStandardComponentWrapper } from 'helpers/HOC';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';

export type FormContainerProps = Content.Rte_Component & {
  isSidenavPart?: boolean;
  params: {
    rteField: string;
  };
};
const FormContainer = (props: FormContainerProps): JSX.Element => {
  const phKey = `cw-form-container-${props?.params?.DynamicPlaceholderId || 1}`;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const fieldMappings = [
      {
        queryParam: 'pageUrl',
        inputName: 'Page URL',
      },
      {
        queryParam: 'providerName',
        inputName: 'URL Provider Name',
      },
      {
        queryParam: 'specialties',
        inputName: 'URL Specialties',
      },
      {
        queryParam: 'locationName',
        inputName: 'URL Location Name',
      },
    ];

    const valuesToPopulate = fieldMappings
      .map((mapping) => ({
        ...mapping,
        value: params.get(mapping.queryParam),
      }))
      .filter((mapping): mapping is typeof mapping & { value: string } => !!mapping.value);

    if (valuesToPopulate.length === 0) {
      return;
    }

    const populateFields = () => {
      let foundAnyInput = false;

      fieldMappings.forEach(({ queryParam, inputName }) => {
        const input = document.querySelector(
          `input[name="${inputName}"]`
        ) as HTMLInputElement | null;

        if (!input) {
          return;
        }

        foundAnyInput = true;

        const value = params.get(queryParam);

        // No query parameter value?
        // Remove the name so the field won't be submitted.
        if (!value) {
          console.log(`Removing field from submission: ${inputName}`);

          input.removeAttribute('name');

          return;
        }

        // Populate the field when a value exists.
        if (input.value !== value) {
          input.value = value;

          console.log(`Populated ${inputName}: ${value}`);
        }
      });

      return foundAnyInput;
    };

    // Try immediately in case the form is already rendered
    if (populateFields()) {
      return;
    }

    const observer = new MutationObserver(() => {
      const populated = populateFields();

      if (populated) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Safety valve in case the form never appears
    const timeout = setTimeout(() => {
      observer.disconnect();
    }, 10000);

    return () => {
      observer.disconnect();
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div>
      <PlaceholderWrapper name={phKey} rendering={props.rendering} />
    </div>
  );
};

export const Default = withStandardComponentWrapper(FormContainer, false);
